<template lang="pug" src="./hero-home-video.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      loaded: false,
      playing: true,
      isMobile: false
    }
  },
  methods: {
    togglePlayPause () {
      const video = document.getElementById('video')
      console.log('HETH')
      if (video.paused) {
        this.playing = true
        video.play()
      } else {
        this.playing = false
        video.pause()
      }
    },
    handleResize (e) {
      this.isMobile = e.matches // Update isMobile based on the query match
    }
  },
  async mounted () {
    setTimeout(e => { this.loaded = true }, 400)
    // Define the media query
    const mediaQuery = window.matchMedia('(max-width: 768px)')

    // Set initial value based on the current window size
    this.isMobile = mediaQuery.matches

    // Add event listener
    mediaQuery.addListener(this.handleResize)
    setTimeout(() => {
      console.log('mobile', this.isMobile)
    }, 2000)
  },
  beforeDestroy () {
    // Clean up: remove event listener
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    mediaQuery.removeListener(this.handleResize)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hero/hero-home-video/hero-home-video.vue